<template>
  <v-app>
    <div class="animated fadeIn">

      <ddoWaiting :value="loading" :message="$t('texts.loading')"/>

      <ddoClientList :loading="loading" :level="levels[0]" 
          :columns="levels[0].columns" :options="levels[0].options" :callbacks="levels[0].callbacks"
          :customSlotNames="levels[0].customSlotNames"
          @loading="refresh_loading"
          @row="refresh_row"
          @childKey="refresh_childKey"
          @errors="refresh_errors"
          >

          <template slot="xxx_steps" slot-scope="props">
            <small><ul>
              <li v-for="step in computedSteps(props.row.xxx_steps)">{{ step }}</li>
            </ul></small>
          </template>

          <template v-slot:dialogform="{ row, level }">
            <CardUpdatableShortcode ref="myCardUpdatable" :row="levels[0].row" :depth="levels[0].level" :level="levels[0]"
              @errors="refresh_errors"
            />
          </template>

          <template v-slot:child_row="{ props }">
          </template>

        <template v-slot:superheader="{ errors }">
          <h2>{{ $t('titles.shc') }}</h2>
        </template>

      </ddoClientList>

    </div>
  </v-app>
</template>

<script>
import Vue from 'vue';
import i18n from '@/plugins/i18n.js';
import BasicList from '@/views/BasicList.vue';
import { Event } from '@/components/ddoClientList.vue';

import CardUpdatableShortcode from '@/components/partials/CardUpdatableShortcode.vue';

let initial_row = {}

export default {
  name: 'shortcode',
  mixins: [BasicList],
  components: {
    CardUpdatableShortcode,
  },
  data: () => {
    return {
      _this: null,
      loading: false,

      /* 
       * LEVEL 1 : all for ddoClientList : columns, options, callbacks
       */
      levels: [

      {
        api_code: 'shortcode',
        api_prefix: 'shc',
        row: { plf_pk: null, shc_code: null, shc_name: null, shc_desc: null, shc_steps: [] },
        level: 0,
        errors: [],
        columns: [ '_actions', 'shc_pk', 'shc_name', 'shc_compactcode', 'xxx_steps', 'plf_name', '_update'],
        customSlotNames: ['xxx_steps'],
        searchValues: {
          net_public: null,
          net_ipnature: '4',
        },
        options: {
          showChildRowToggler: false,
          withChild: false,
          hiddenColumns: [],
          headings: {
            _pk: i18n.t('headers.actions'),
            shc_name: i18n.t('headers.name'),
            shc_compactcode: i18n.t('texts.shc_compactcode'),
            plf_name: i18n.t('headers.plf_name'),
            xxx_steps: i18n.t('headers.xxx_steps'),
            shc_pk: '#',
            _update: i18n.t('headers.updated_on')
          },
          texts: {
          },
          uniqueKey: 'shc_pk',
          sortable: ['shc_code','_update'],
          filterable: false,
          sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
          columnsDropdown: false,
          pagination: {
            chunk: 5,
            edge: false,
            nav: 'scroll'
          },
          columnsDisplay: {
            _update: 'desktop',
            shc_desc: 'desktop',
            shc_pk: 'desktop',
          },
          customFilters: [],
        },
        callbacks: {
        },
        dialogOptions: {
          codeRules : [
            (v) => !!v || i18n.t('texts._required')
          ]
        },
        dialogValues: {
          headers: {
            create: i18n.t('texts.shc_create_title'),
            update: i18n.t('texts.shc_update_title'),
            delete: i18n.t('texts.shc_delete_title'),
          },
          macros: [],
          samePLF: true,
          dialogShow: false,
          form_disabled: false,
          form_close: true,
          form_create: false,
          form_update: false,
          form_delete: false,
          disable_create: false,
          disable_update: false,
          disable_delete: false,
          header_value_function: function(row) { return row['shc_code']; }
       },
      },

      ],

      useVuex: false,
      theme: 'bootstrap4',
      template: 'default',
    }
  },

  created() {
    this._this = this;
    this.levels[0].callbacks.configure_form = this.configure_form;
    this.levels[0].callbacks.prepare_create = this.prepare_create;    
    this.levels[0].callbacks.prepare_update = this.prepare_update;    
    this.levels[0].callbacks.prepare_delete = this.prepare_delete;    
    this.levels[0].callbacks.show_dialog    = this.show_dialog;
    this.levels[0].callbacks.refresh_errors = this.refresh_errors;
  },

  async mounted() {
    await this.build_macros_list();
  },

  methods: {

    computedSteps(steps) {
      // steps is a comma-separated string. We need to transform it in an array
      if ( typeof steps == "string" ) {
        return steps.split(',');
      } else {
        return [];
      }
    },

    prepare_create(parentKey=null) {
       this.$refs.myCardUpdatable.PLFoptions.disabled = false;
       this.$refs.myCardUpdatable.PLFoptions.initial  = null;
    },

    async prepare_update(parentKey=null) {
       this.$refs.myCardUpdatable.PLFoptions.disabled = false;
       this.$refs.myCardUpdatable.PLFoptions.initial  = this.levels[0].row.plf_pk;
       await this.$refs.myCardUpdatable.build_steps_list(this.levels[0].row);
       this.$refs.myCardUpdatable.clear_macros_list();
    },

    async prepare_delete(parentKey=null) {
       this.$refs.myCardUpdatable.PLFoptions.disabled = true;
       this.$refs.myCardUpdatable.PLFoptions.initial  = this.levels[0].row.plf_pk;
       await this.$refs.myCardUpdatable.build_steps_list(this.levels[0].row);
    },

    async build_macros_list() {
      this.loading = true;
      /*
       * This call to 'runmacroaction' must return an xxx_pk and xxx_skippable for each macro/action.
       * THis is required for steps of shortcode, when updating shortcode (see shc_steps)
      */
      var { errorinfos, api_response } = await this.$api.getRows(this.$router,'runmacroaction');
      this.loading = false;
      if ( api_response.error==0 && api_response.rows ) {
        this.levels[0].dialogValues.macros = api_response.rows;
        this.$refs.myCardUpdatable.clear_macros_list();
      }
    },

  }
}
</script>